import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getEmailId, fetchProgramCourseImageById } from '../redux/actions/Actions';
import { useLocation, useNavigate } from 'react-router-dom';

const PdfIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="rgba(255,255,255,0.15)" />
    <path d="M14 12h14l8 8v20a2 2 0 01-2 2H14a2 2 0 01-2-2V14a2 2 0 012-2z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M28 12v8h8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 28h12M18 32h8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 24h4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const DownloadArrow = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3v13M7 11l5 5 5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 21h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
)

const DownloadLesson = () => {
  const location      = useLocation()
  const navigate      = useNavigate()
  const dispatch      = useDispatch()

  const fetchProgramsCourseFiles = useSelector((state) => state.fetchProgramCourseFiles.programCourseFilesById)
  const authUser        = useSelector((state) => state.auth.user)
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)

  const courseInterested   = location.state?.interestedCourse   || ''
  const courseInterestedId = location.state?.interestedCourseId  || ''
  const programId          = location.state?.Program_id          || ''
  const programInterested  = location.state?.programInterested   || ''
  const directPdfFilePath  = location.state?.pdfFilePath          || ''
  const isProgramBrochure  = location.state?.isProgramBrochure    || false

  const [pdfFilePath, setPdfFilePath] = useState(directPdfFilePath)
  const [opened,      setOpened]      = useState(false)

  const noIds = !programId || !courseInterestedId
  const noBrochure = isProgramBrochure && !directPdfFilePath

  useEffect(() => {
    if (!directPdfFilePath && !noIds && !isProgramBrochure) {
      dispatch(fetchProgramCourseImageById(programId, courseInterestedId))
    }
  }, [dispatch, programId, courseInterestedId, directPdfFilePath, isProgramBrochure])

  useEffect(() => {
    if (!directPdfFilePath && !isProgramBrochure && fetchProgramsCourseFiles.length > 0) {
      const match = fetchProgramsCourseFiles.find(
        (f) => String(f.course_id) === String(courseInterestedId)
      )
      if (match) setPdfFilePath(match.pdf_file_path)
    }
  }, [fetchProgramsCourseFiles, directPdfFilePath, isProgramBrochure, courseInterestedId])

  useEffect(() => {
    if (!pdfFilePath) return

    if (isAuthenticated) {
      dispatch(getEmailId({
        email:             authUser?.email || localStorage.getItem('email') || '',
        phone_number:      authUser?.phone_number || '',
        course_id:         courseInterestedId,
        program_course_id: null,
      }))
    }
    window.open(pdfFilePath, '_blank')
    setOpened(true)
  }, [pdfFilePath])

  const handleManualOpen = () => {
    if (pdfFilePath) window.open(pdfFilePath, '_blank')
  }

  return (
    <div style={s.page}>

      {/* ── Hero gradient header ── */}
      <div style={s.hero}>
        <div style={s.breadcrumb}>
          <span style={s.breadcrumbSep}>&#10094;</span>
          <span style={s.breadcrumbText}>UPLSNIPE</span>
          <span style={s.breadcrumbSep}>|</span>
          <span style={s.breadcrumbText}>{programInterested.toUpperCase() || 'PROGRAM'}</span>
          <span style={s.breadcrumbSep}>|</span>
          <span style={{ ...s.breadcrumbText, color: '#fff', fontWeight: 900 }}>
            {courseInterested.toUpperCase() || 'COURSE'}
          </span>
          <span style={s.breadcrumbSep}>&#10095;</span>
        </div>

        <div style={s.pdfIconWrap}>
          <PdfIcon />
        </div>

        <h1 style={s.heroTitle}>{noIds ? 'Request Received!' : 'Your Syllabus is Ready'}</h1>
        <p style={s.heroSub}>
          {noIds ? programInterested : `${courseInterested} — ${programInterested}`}
        </p>
      </div>

      {/* ── Card ── */}
      <div style={s.cardWrap}>
        <div style={s.card}>

          {noBrochure ? (
            /* Program-level brochure requested but not available — don't fall back to another brochure */
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#EEF2FF,#DBEAFE)', border: '2px solid #C7D2FE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h3 style={{ fontSize: 20, fontWeight: 800, color: '#0F172A', margin: '0 0 10px' }}>Brochure Coming Soon</h3>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, margin: '0 0 24px' }}>
                The brochure for <strong>{programInterested}</strong> isn't available yet.<br />
                Our team will share it with you shortly via WhatsApp or call.
              </p>
              <button style={s.downloadBtn} onClick={() => navigate(-1)}>
                ← Back to Program
              </button>
            </div>
          ) : noIds ? (
            /* No IDs — brochure request confirmed */
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#EEF2FF,#DBEAFE)', border: '2px solid #C7D2FE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h3 style={{ fontSize: 20, fontWeight: 800, color: '#0F172A', margin: '0 0 10px' }}>You're All Set!</h3>
              <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, margin: '0 0 24px' }}>
                Thank you for your interest in <strong>{programInterested}</strong>.<br />
                Our team will share the brochure with you shortly via WhatsApp or call.
              </p>
              <button style={s.downloadBtn} onClick={() => navigate(-1)}>
                ← Back to Program
              </button>
            </div>
          ) : !pdfFilePath ? (
            /* Loading state */
            <div style={s.loadingWrap}>
              <div style={s.spinner} />
              <p style={s.loadingText}>Preparing your PDF…</p>
            </div>
          ) : (
            /* Ready state */
            <>
              <div style={s.statusRow}>
                <div style={s.statusDot} />
                <span style={s.statusText}>
                  {opened ? 'PDF opened in a new tab' : 'PDF ready to open'}
                </span>
              </div>

              <div style={s.divider} />

              <div style={s.fileCard}>
                <div style={s.fileIcon}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2v6h6" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 15h6M9 11h4" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={s.fileInfo}>
                  <p style={s.fileName}>{courseInterested || 'Syllabus'}.pdf</p>
                  <p style={s.fileLabel}>Course Syllabus · PDF Document</p>
                </div>
              </div>

              <button style={s.downloadBtn} onClick={handleManualOpen}
                onMouseEnter={e => e.currentTarget.style.background = '#1D4ED8'}
                onMouseLeave={e => e.currentTarget.style.background = '#2563EB'}>
                <DownloadArrow />
                {opened ? 'Open Again' : 'Open PDF'}
              </button>

              <button style={s.backBtn} onClick={() => navigate(-1)}
                onMouseEnter={e => { e.currentTarget.style.background='#F1F5F9'; e.currentTarget.style.borderColor='#94A3B8'; }}
                onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.borderColor='#E2E8F0'; }}>
                ← Back to Course
              </button>
            </>
          )}
        </div>

        <p style={s.hint}>
          PDF opens in a new browser tab. If it doesn't open, check your popup blocker settings.
        </p>
      </div>

    </div>
  )
}

const s = {
  page: {
    minHeight:  '100vh',
    background: '#F8FAFC',
    fontFamily: "'Inter','Segoe UI',sans-serif",
    display:    'flex',
    flexDirection: 'column',
  },

  /* Hero */
  hero: {
    background:     'linear-gradient(180deg,#0D9488 0%,#0EA5E9 35%,#2563EB 70%,#1D4ED8 100%)',
    padding:        '60px 5% 80px',
    textAlign:      'center',
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    gap:            16,
  },
  breadcrumb: {
    display:    'flex',
    alignItems: 'center',
    gap:        8,
    marginBottom: 8,
    opacity:    0.9,
  },
  breadcrumbText: {
    fontSize:      12,
    fontWeight:    700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color:         'rgba(255,255,255,0.75)',
  },
  breadcrumbSep: {
    color:    'rgba(255,255,255,0.4)',
    fontSize: 13,
  },
  pdfIconWrap: {
    marginBottom: 8,
  },
  heroTitle: {
    fontSize:      'clamp(28px,4vw,48px)',
    fontWeight:    800,
    color:         '#fff',
    letterSpacing: '-0.03em',
    lineHeight:    1.1,
    margin:        0,
  },
  heroSub: {
    fontSize:   16,
    color:      'rgba(255,255,255,0.80)',
    margin:     0,
    lineHeight: 1.5,
  },

  /* Card */
  cardWrap: {
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    padding:        '0 20px 60px',
    marginTop:      -40,
  },
  card: {
    background:   '#fff',
    borderRadius: 20,
    border:       '1px solid #E2E8F0',
    boxShadow:    '0 8px 40px rgba(0,0,0,0.10)',
    padding:      '40px 48px',
    width:        '100%',
    maxWidth:     480,
    display:      'flex',
    flexDirection:'column',
    gap:          20,
  },

  /* Loading */
  loadingWrap: {
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    padding:        '24px 0',
    gap:            16,
  },
  spinner: {
    width:           40,
    height:          40,
    border:          '4px solid #E2E8F0',
    borderTopColor:  '#2563EB',
    borderRadius:    '50%',
    animation:       'spin 0.8s linear infinite',
  },
  loadingText: {
    color:    '#64748B',
    fontSize: 15,
    margin:   0,
  },

  /* Status */
  statusRow: {
    display:    'flex',
    alignItems: 'center',
    gap:        8,
  },
  statusDot: {
    width:        10,
    height:       10,
    borderRadius: '50%',
    background:   '#22C55E',
    flexShrink:   0,
  },
  statusText: {
    fontSize:   14,
    color:      '#16A34A',
    fontWeight: 600,
  },
  divider: {
    borderTop: '1px solid #F1F5F9',
    margin:    '0 -48px',
  },

  /* File card */
  fileCard: {
    display:      'flex',
    alignItems:   'center',
    gap:          14,
    padding:      '16px 20px',
    background:   '#F8FAFC',
    borderRadius: 12,
    border:       '1px solid #E2E8F0',
  },
  fileIcon: {
    width:          52,
    height:         52,
    background:     '#EFF6FF',
    borderRadius:   10,
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    flexShrink:     0,
  },
  fileInfo: {
    display:       'flex',
    flexDirection: 'column',
    gap:           3,
  },
  fileName: {
    fontSize:   15,
    fontWeight: 700,
    color:      '#0F172A',
    margin:     0,
    wordBreak:  'break-word',
  },
  fileLabel: {
    fontSize: 12,
    color:    '#94A3B8',
    margin:   0,
  },

  /* Buttons */
  downloadBtn: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    gap:            8,
    padding:        '14px',
    background:     '#2563EB',
    color:          '#fff',
    border:         'none',
    borderRadius:   10,
    fontSize:       15,
    fontWeight:     700,
    letterSpacing:  '0.05em',
    cursor:         'pointer',
    transition:     'background 0.2s',
    width:          '100%',
  },
  backBtn: {
    padding:      '12px',
    background:   'transparent',
    color:        '#64748B',
    border:       '1.5px solid #E2E8F0',
    borderRadius: 10,
    fontSize:     14,
    fontWeight:   600,
    cursor:       'pointer',
    transition:   'all 0.2s',
    width:        '100%',
  },

  hint: {
    marginTop: 16,
    fontSize:  12,
    color:     '#94A3B8',
    textAlign: 'center',
    maxWidth:  400,
    lineHeight: 1.6,
  },
}

export default DownloadLesson
